export default __webpack_public_path__ + "static/media/prata.c7860064.svg";